import styled from 'styled-components'
import { breakpoints } from '../../../../../../constants'
import {
	WHITE,
	MEDIUMORANGE
} from '../../../../../../styles/colors.style'

export const Button = styled.button`
	border: 0;
	border-radius: 5px;
	width: 260px;
	height: 50px;
	display: block;
	margin: 0 auto;
	color: ${WHITE};
	background: ${MEDIUMORANGE};
	font: 600 16px/50px 'Source Sans Pro';
	text-align: center;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}

	&.upper {
		text-transform: uppercase;
	}
`

export const ResumeCard = styled.div`
	min-height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;

	&.-allDevices {
		display: flex;
	}

	&.-desktop {
		display: none;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 310px;
		background: transparent;
		display: none;

		&.-desktop {
			display: flex;
		}
	}
`
